(function () {
  const BlendQuiz = window.BlendQuiz = window.BlendQuiz || {};

  // Quiz v2: one call. The engine owns scoring, formula and copy, and saves the blob itself.
  // savedId is the blob id ("blend-<id>") that the PDP and getBlend use.
  BlendQuiz.createBlendV2 = async function ({ answers, leaveOut = [] }) {
    const apiResult = await window.quizStateManager.createBlendV2(answers, { leaveOut });
    const savedId = 'blend-' + apiResult.blendId;
    window.quizStateManager.setLastBlendId(savedId);

    // Record this anonymous run with the portal so it can be claimed at login (fire-and-forget).
    window.quizStateManager.recordQuizSession({
      blendId: savedId,
      categories: apiResult.profile,   // the engine's percentages, e.g. { "Woody & Earthy": 26, ... }
      quizVersion: 'v2',
    });

    return { savedId, apiResult };
  };
})();
